import Container from "@components/Atomic/Container/Container";
import { Link } from "@components/Link/Link";
import React from "react";
import ImageGridCard from "./ImageGridCard";
import { withImageGrid } from "./withImageGrid";

import { clsx } from "clsx";

const Wrapper = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "w-full max-w-full",
      props.cols === 1 &&
        props.spacing &&
        "mx-auto max-w-2xl px-giga sm:px-tera md:px-exa xl:px-[288px]",
      props.cols === 2 &&
        props.spacing &&
        "sm:px-3-6 mx-auto max-w-2xl px-mini md:px-tera xl:px-exa",
      props.cols > 2 &&
        props.spacing &&
        "sm:px-3-6 mx-auto max-w-2xl px-mini md:px-tera",
    )}
  />
);

const CardWrapper = (props: any) => (
  <div {...props} className={clsx(props.className, "flex flex-wrap")} />
);

const TitleSection = (props: any) => (
  <div {...props} className={clsx(props.className, "block")} />
);

const Title = (props: any) => (
  <h2
    {...props}
    className={clsx(
      props.className,
      "mb-mini text-center font-display text-h2 leading-h2 md:mb-midi md:text-h1 md:leading-h4 xl:text-[56px]",
    )}
  />
);

const CTAWrapper = (props: any) => (
  <div {...props} className={clsx(props.className, "flex justify-center")} />
);

const StyledLink = (props: any) => (
  <Link
    {...props}
    className={clsx(
      props.className,
      "mb-maxi inline-block border-b pb-pico text-body md:hidden",
    )}
  />
);

const ImageGrid = withImageGrid(
  ({
    spacing,
    link,
    title,
    cols,
    contents,
    background,
    showTitle,
    textColour,
    styles,
  }) => {
    return (
      <Container
        styles={styles}
        legacy={!styles?.length}
        background={background}
        textColour={textColour}
        data-component-type="section-image-grid"
      >
        {contents ? (
          <Wrapper spacing={spacing} cols={cols}>
            {showTitle ? (
              <TitleSection data-testid="title-section">
                {title && <Title>{title}</Title>}
                {link?.url ? (
                  <CTAWrapper>
                    <StyledLink to={link?.url}>{link?.title}</StyledLink>
                  </CTAWrapper>
                ) : null}
              </TitleSection>
            ) : null}
            <CardWrapper>
              <ImageGridCard
                spacing={spacing}
                cols={cols}
                contents={contents}
                textColour={textColour}
              />
            </CardWrapper>
          </Wrapper>
        ) : null}
      </Container>
    );
  },
);

export default ImageGrid;
